var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"warp"},[_c('el-col',{staticClass:"warp-breadcrum",attrs:{"span":24}},[_c('el-carousel',{attrs:{"interval":4000,"type":"card","height":"600px"}},_vm._l((_vm.imagesbox),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"image",attrs:{"src":item.idView}})])}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2249ec5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/visualization.vue
// module id = null
// module chunks = 